import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Stack,
  Typography,
} from '@mui/material';

import { useSurveyList } from 'src/components/survey/SurveyContext/ListContext';
import WidgetTile from 'src/components/survey/SurveySelectionPage/components/SurveyWidgetView/WidgetTile';

import { styles } from './index.styles';

const TRANSITION_TIMEOUT = 300;

const SurveyWidgetView = () => {
  const { surveysGroupedByProjectCategory } = useSurveyList();
  // Manually control accordion to only dispatch widget requests on expand
  const [expanded, setExpanded] = useState<number[]>(
    Object.keys(surveysGroupedByProjectCategory).map((_, i) => i),
  );

  useEffect(() => {
    if (!expanded.length) {
      // Expend all by default
      setExpanded(
        Object.keys(surveysGroupedByProjectCategory).map((_, i) => i),
      );
    }
  }, [surveysGroupedByProjectCategory]);

  // wait for transitions so that the widgets can check if they are on screen
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setInitialized(true), TRANSITION_TIMEOUT);
    return () => clearTimeout(timer);
  }, []);

  const toggleExpand = (index: number) =>
    setExpanded((prev) =>
      prev.includes(index)
        ? prev.filter((prevIndex) => prevIndex !== index)
        : [...prev, index],
    );

  return (
    <Stack spacing={3}>
      {Object.entries(surveysGroupedByProjectCategory).map(
        ([projectId, { projectCategoryName, surveys }], projectIndex) => (
          <Box key={`survey-selection-${projectId}-${projectIndex}`}>
            <Accordion
              elevation={0}
              sx={styles.accordion}
              expanded={expanded.includes(projectIndex)}
              onChange={() => toggleExpand(projectIndex)}
              slotProps={{ transition: { timeout: TRANSITION_TIMEOUT } }}
            >
              <AccordionSummary
                sx={styles.accordionSummary}
                expandIcon={<ExpandMoreIcon color="primary" />}
              >
                <Typography variant="h6">{projectCategoryName}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={styles.accordionDetails}>
                <Box>
                  <Grid container spacing={2.5}>
                    {surveys.map((survey, surveyIndex) => (
                      <Grid
                        key={`widget-${surveyIndex}`}
                        item
                        xs={12}
                        md={6}
                        lg={4}
                      >
                        <WidgetTile
                          survey={survey}
                          enabled={
                            expanded.includes(projectIndex) && initialized
                          }
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Box sx={styles.accordionFooter} />
          </Box>
        ),
      )}
    </Stack>
  );
};

export default SurveyWidgetView;
